export default __webpack_public_path__ + "74fe7d1d4761bc9489c21b2073b20ee4.png";